import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";

import "../css/scrollbar.css";

import ViewSales from "./ViewSales";
import AddEditBackOrder from "./AddEditBackOrder";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxesPacking,
  faFileInvoice,
  faMagnifyingGlassArrowRight,
} from "@fortawesome/free-solid-svg-icons";

import ChargeInclusion from "../Administrator/ChargeInclusion";

const ChargeSummary = (props) => {
  return (
    <>
      <MDBCard>
        <MDBCardHeader className="cloudy-knoxville-gradient">
          <span
            className="h5-responsive blue-text"
            style={{
              fontFamily: "Montserrat",
              fontWeight: "400",
            }}
          >
            <span className="blue-text">
              <FontAwesomeIcon icon={faFileInvoice} />
            </span>
            &nbsp;Summary of Charges
          </span>
        </MDBCardHeader>

        <MaterialTable
          title=""
          columns={[
            {
              title: "Date/Time",
              field: "transactiondatetextsales",
              type: "datetime",
              hidden: true,
            },
            {
              title: "Item",
              field: "item",

              render: (rowData) => (
                <>
                  <span className="font-weight-bold">
                    <strong>{rowData.descriptiondetailed}</strong>
                  </span>{" "}
                  <br />
                  <span className="small">
                    {rowData.transactiontype == "BACK ORDER" ? (
                      <span className="font-weight-bold red-text">
                        {rowData.ChargeType}{" "}
                        <small>({rowData.transactiontype})</small>
                      </span>
                    ) : (
                      <span className="black-text">{rowData.ChargeType}</span>
                    )}
                  </span>
                  {Boolean(rowData.outsourced) === false ? (
                    ""
                  ) : (
                    <>
                      <br />
                      <small>
                        <span className="green-text  font-weight-bold">
                          {" "}
                          <FontAwesomeIcon
                            icon={faMagnifyingGlassArrowRight}
                            size="1x"
                          />
                          &nbsp; OUTSOURCED
                        </span>
                      </small>
                    </>
                  )}
                  <br />
                  <span className="small">
                    {rowData.transactiondatetextsales}
                  </span>
                </>
              ),
              width: "70%",
            },

            { title: "code", field: "code", hidden: true },

            { title: "Price", field: "price" },

            // { title: "ItemCode", field: "itemcode" },
            // { title: "PackageCode", field: "packagecode" },

            { title: "Qty", field: "quantity" },

            { title: "Total Price", field: "totalprice" },
            {
              title: "Charge Type",
              field: "ChargeType",
              hidden: true,
            },
          ]}
          data={props.rows}
          options={{
            search: true,
            actionsColumnIndex: -1,
            pageSize: 10,
            pageSizeOptions: [
              { value: props.length, label: "All" },
              10,
              25,
              50,
              100,
            ],

            detailPanelType: "single",
          }}
          detailPanel={[
            {
              icon: () => <MDBIcon icon="list" className="blue-text" />,
              openIcon: () => (
                <MDBIcon icon="chevron-circle-down" className="red-text" />
              ),
              tooltip: "Charge Details",
              render: (rowData) => {
                return (
                  <React.Fragment>
                    <MDBContainer className="ml-0 p-0" fluid>
                      <MDBCardHeader className="cloudy-knoxville-gradient">
                        <span className="font-weight-bold">
                          {" "}
                          Charge Details
                        </span>
                      </MDBCardHeader>
                      <MDBCardBody>
                        <ViewSales
                          deployURL={props.deployURL}
                          apiServer={props.apiServer}
                          code={rowData.code}
                          parentcode={props.parentcode}
                          dealercode={props.dealercode}
                          apiServerHybrid={props.apiServerHybrid}
                          returned={false}
                          toggleModal={props.toggleAddEdit}
                          refreshGrid={props.refreshGrid}
                          // refreshSalesMain={props.refreshGrid}
                          showResult={props.showResult}
                          totalSales={props.totalSales}
                          setTotalSales={props.setTotalSales}
                          checkTotalSales={props.checkTotalSales}
                          opencpdnew={props.opencpdnew}
                          discountLimit={props.discountLimit}
                          discountInWeek={props.discountInWeek}
                          setDiscountInWeek={props.setDiscountInWeek}
                          getdiscountinweek={props.getdiscountinweek}
                        ></ViewSales>
                      </MDBCardBody>
                      <MDBCardFooter></MDBCardFooter>
                    </MDBContainer>
                  </React.Fragment>
                );
              },
            },
            {
              icon: () => (
                // <MDBIcon icon="list" className="blue-text" />
                <FontAwesomeIcon
                  icon={faBoxesPacking}
                  className="purple-text"
                />
              ),
              openIcon: () => (
                <MDBIcon icon="chevron-circle-down" className="red-text" />
              ),
              tooltip: "Inclusions",
              render: (rowData) => {
                return (
                  <React.Fragment>
                    <MDBContainer className="ml-0 p-0" fluid>
                      {(rowData.ChargeType === "PACKAGE") |
                      (rowData.ChargeType === "SERVICE") ? (
                        <>
                          <MDBCardHeader className="cloudy-knoxville-gradient">
                            <span className="font-weight-bold">
                              {" "}
                              Inclusions {"(" + rowData.code + ")"}
                            </span>
                          </MDBCardHeader>
                          <ChargeInclusion
                            deployURL={props.deployURL}
                            apiServer={props.apiServer}
                            apiServerHybrid={props.apiServerHybrid}
                            toggleModal={props.toggleAddEdit}
                            refreshGrid={props.refreshGrid}
                            packagecode={rowData.packagecode}
                            parentcode={props.parentcode}
                            salescode={rowData.code}
                          ></ChargeInclusion>

                          <MDBCardFooter></MDBCardFooter>
                        </>
                      ) : (
                        ""
                      )}
                    </MDBContainer>
                  </React.Fragment>
                );
              },
            },

            {
              icon: () => <MDBIcon icon="undo-alt" className="brown-text" />,
              openIcon: () => (
                <MDBIcon icon="chevron-circle-down" className="brown-text" />
              ),
              tooltip: "Return Items",
              render: (rowData) => {
                return (
                  <MDBContainer className="ml-0">
                    <MDBCardHeader className="cloudy-knoxville-gradient">
                      <span className="font-weight-bold"> Return Items</span>
                    </MDBCardHeader>
                    <MDBCardBody>
                      <AddEditBackOrder
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        code={rowData.code}
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        apiServerHybrid={props.apiServerHybrid}
                        discountcode={props.discountcode}
                        discounttype={props.discounttype}
                        discountrate={props.discountrate}
                        returned={true}
                        toggleModal={props.toggleAddEdit}
                        refreshGrid={props.refreshGrid}
                        // refreshSalesMain={props.refreshGrid}
                        showResult={props.showResult}
                        totalSales={props.totalSales}
                        setTotalSales={props.setTotalSales}
                        checkTotalSales={props.checkTotalSales}
                      ></AddEditBackOrder>
                    </MDBCardBody>
                    <MDBCardFooter></MDBCardFooter>
                  </MDBContainer>
                );
              },
            },
          ]}
        />
      </MDBCard>
    </>
  );
};

export default ChargeSummary;
